export default __webpack_public_path__ + "static/logo-e0f557aeba6f16a9f5201596276e6f63.png";